var React = require("react");
var ReactDOM = require("react-dom");
const createReactClass = require("create-react-class");
const PropTypes = require("prop-types");

var validate_domain = require('./validate_domain.js');

module.exports = createReactClass({

	getInitialState: function() {
		return {
			error: ""
		}
	},
	componentWillReceiveProps: function(nextProps) {
		var errMessage = validate_domain(nextProps.value);
		this.setState({
			error: errMessage
		});
	},
	propTypes: {
		// no id means that this is a new item
		id: PropTypes.node,
		type: PropTypes.string,
		value: PropTypes.string,
		placeholder: PropTypes.string,
		disabled: PropTypes.bool,
		onChange: PropTypes.func.isRequired
	},
	change: function(e) {
		var errMessage = validate_domain(e.target.value);

		this.props.onChange({
			action: (typeof this.props.id !== 'undefined') ? "change" : "add",
			id: this.props.id,
			type: this.props.type,
			value: e.target.value,
			error: (errMessage !== "")
		});
	},

	focus: function() {
		ReactDOM.findDOMNode(this.refs.input_field).focus();
	},

	render: function() {
		return (
			<td>
				<div className="form-group">
					<input
						ref="input_field"
						name={this.props.id + "_" + this.props.type}
						placeholder={this.props.placeholder}
						type="text"
						className="form-control"
						value={this.props.value}
						disabled={this.props.disabled}
						onChange={this.change}
					/>
					<div className="validation-message">{this.state.error}</div>
				</div>
			</td>
		);
	}
});
